// extracted by mini-css-extract-plugin
export default {"mapPage":"FOF4KD4CanOC2swIaIhk"};